/* eslint-disable */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { toastError, toastSuccess } from '@/helpers/toast';
import lGet from 'lodash/get';
import { convertJSONToString, errorMessageFromServer } from '@/utils/server';
import { TStepTwoForm } from "@/features/user/register/stepTwo/types";
import { useTranslation } from 'react-i18next';
import { makeRequired, makeValidate } from "mui-rff";
import { schema } from "@/features/user/register/stepTwo/validations";
import { makeYupTranslatedError } from "@/helpers/yup";
import { registerUserStepTwo, registerUserStepTwoData } from "@/apis/register/stepTwo";
import StepTwoForm from '@/features/user/register/stepTwo/components/form';
import { AxiosResponse } from "axios";
import { MenuItem } from "@mui/material";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setBackdrop } from "@/store/slices/appSlice";
import { checkErrorResponse } from "@/helpers/axios";

const StepTwo = ({ isModal, closePopover, stepperCallback, from = "Route" }: any): any => {
    //console.log("@StepTwo loading component from ", from);

    const [t] = useTranslation();

    const [loading, setLoading] = useState(true);

    // to know if modal is open
    const [modalOpen, setModalOpen] = useState(false);

    const [submitting, setSubmitting] = useState(false);

    const initialValues: any = {
        calle: '',
        no_exterior: '',
        no_interior: '',
        colonia: '',
        referencia: '',
        municipio: '',
        localidad: '',
        estado: '',
        pais: 'México',
        codigo_postal: ''
    };

    // hack to override values when component mounts
    const initialValuesRef = useRef<any>(initialValues);

    const validateForm = makeValidate(schema, makeYupTranslatedError);

    const required = makeRequired(schema);

    const getData = useCallback(async () => {
        // set loader
        setLoading(true);

        // call user data promise
        const promiseAddressData = registerUserStepTwoData();

        try {
            // promise all
            // promise all
            const results = await Promise.all<Promise<AxiosResponse>>([promiseAddressData]);

            // set initial values
            const user_address_data = results[0].data.user_address_data;
            initialValuesRef.current = { ...initialValuesRef.current, ...user_address_data };
        } catch (e) {
            checkErrorResponse(e);
        } finally {
            // stop loading
            setLoading(false);
        }
    }, []);

    const history = useHistory();
    const dispatch = useDispatch();
    const submitData = useCallback(async (payload: any) => {
        setSubmitting(true);

        try {
            const response = await registerUserStepTwo(payload);
            toastSuccess(response.data.message, {
                onOpen: () => (isModal) && dispatch(setBackdrop(true)),
                onClose: () => (isModal) && history.go(0)
            });
            // sense changes in complete register
            if (!isModal && stepperCallback) {
                stepperCallback();
            }
            return true;
        } catch (error) {
            if (lGet(error, 'data')) {
                const errors = error.data.errors;
                const message = errorMessageFromServer(convertJSONToString(errors));
                toastError(message);
            } else {
                console.error('error: ', error);
                checkErrorResponse(error);
            }
            return false;
        } finally {
            setSubmitting(false);
        }
    }, []);

    // yes, this can even be async!
    const onSubmit = async (values: any) => {
        return submitData(values).catch((e) => console.error(e));
    };

    useEffect(() => {
        if (!isModal)
            getData().catch((e) => console.error(e));
    }, []);

    useEffect(() => {
        //console.log("@StepTwo sensing value modalOpen: ", modalOpen);
        if (modalOpen) {
            //console.log("@StepTwo modal is open and not loaded data first time");
            getData().catch((e: any) => console.error(e));
        }
    }, [modalOpen])

    const formProps: TStepTwoForm = {
        onSubmit,
        initialValues: initialValuesRef.current,
        validateForm,
        required,
        submitting,
        isModal,
        closePopover,
        setModalOpen,
        loading
    };

    //console.log(initialValuesRef.current)

    return (
        <>
            {<StepTwoForm {...formProps} />}

            {/*{(loading && !isModal) && <>{t('common.loading')}</>}

            {(loading && isModal) && <MenuItem>{t('step_two.title')}</MenuItem>}*/}
        </>
    );
}

export default StepTwo;
